var exports = {
  "spinner": "Spinner.module__spinner___MTduZF",
  "spinnerInner": "Spinner.module__spinnerInner___MTduZF",
  "spinnerItem": "Spinner.module__spinnerItem___MTduZF",
  "spinnerPulsingEllipsis": "Spinner.module__spinnerPulsingEllipsis___MTduZF",
  "small": "Spinner.module__small___MTduZF",
  "medium": "Spinner.module__medium___MTduZF",
  "large": "Spinner.module__large___MTduZF",
  "delay1": "Spinner.module__delay1___MTduZF",
  "delay2": "Spinner.module__delay2___MTduZF",
  "srOnly": "Spinner.module__srOnly___MTduZF",
};

__webpack_require__.r(module.exports = exports);
